<template>
    <div>
        <login :api-url="getApiUrl()" :secret="getApiSecret()"></login>
    </div>
</template>
<script lang="babel">
  import Login from 'src/components/Dashboard/Views/Login.vue'

  export default {
    data () {
      return {}
    },
    methods: {
      getApiUrl () {
        return process.env.API_URL
      },
      getApiSecret () {
        return process.env.API_KEY
      }
    },
    components: {
      Login
    }
  }
</script>



// WEBPACK FOOTER //
// LoginPage.vue?2576ae58